import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper';

function ccUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    uid,
    cid,
    id: uid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/User${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

function ccPayloadFactory(params) {
  const { data } = params;
  return data.User ? data : { User: data };
}

export const mutationRequestContract = createRequestContract({
  schema,
  dataPath: 'user',
  verb: requestVerbs.PATCH,
  fetchPolicy: FetchPolicy.NetworkOnly,
  uriFactoryFn: ccUrlFactory,
  headerFactoryFn: ccOptionsFactory,
  payloadFactoryFn: ccPayloadFactory,
  keySelector: variables => variables.locator.descriptor.uid,
  parentKeySelector: variables => variables.locator.descriptor.uid,
});

export const mutationResponseContract = createResponseContract({
  requestContract: mutationRequestContract,
  responseType: responseTypes.ENTITY,
  keySelector: user => user.id,
  processorFn: response => response,
});
